// constants
export const appConstants = {
  GET_HOTELDATA_REQUEST: "GET_HOTELDATA_REQUEST",
  GET_HOTELDATA_SUCCESS: "GET_HOTELDATA_SUCCESS",
  GET_HOTELDATA_FAILURE: "GET_HOTELDATA_FAILURE",
  ADD_HOTELDATA_REQUEST: "ADD_HOTELDATA_REQUEST",
  ADD_HOTELDATA_SUCCESS: "ADD_HOTELDATA_SUCCESS",
  ADD_HOTELDATA_FAILURE: "ADD_HOTELDATA_FAILURE",
  ADD_HOTELDATA: "ADD_HOTELDATA",
  REMOVE_HOTELDATA_ITEM: "REMOVE_HOTELDATA_ITEM",
  TOGGLE_HOTELDATA_STATUS: "TOGGLE_HOTELDATA_STATUS"
};
